import gql from "graphql-tag";

export const DELETE_LESSON_ATTACHMENT_MUTATION = gql`
  mutation DeleteLessonAttachment($id: Int!) {
    removeLessonAttachment(data: { id: $id }) {
      id
    }
  }
`;
